<template>
  <div class="LmUsersTable">
    <header v-if="columns" class="flex items-center">
      <div
        v-for="column in columns"
        :key="column.id"
        class="Column h-10 flex items-center text-gray-500 cursor-pointer"
        :class="[
          {'w-2/3 md:w-3/5 mr-2': column.id === 'username'}, // hack !?
          {
            'is-sorted text-highlight hover:text-highlight':
              column.id === columnSorted
          }
        ]"
        @click="sort(column, $event)"
      >
        <span class="mr-1 text-s">{{ column.title }}</span>
        <lm-icon
          :icon="column.orderIcon"
          size="16"
          class="SortIcon text-gray-500"
          :class="{
            'text-highlight': column.id === columnSorted
          }"
        />
        <column-role-help v-if="column.help === 'role'" class="ml-2" />
      </div>
    </header>
    <ul>
      <slot />
    </ul>
  </div>
</template>

<script>
import Vue from 'vue'
import LmIcon from '@/components/ui/LmIcon'
import ColumnRoleHelp from '@/components/ui/usersTable/ColumnRoleHelp'
export default {
  name: 'LmUsersTable',
  components: {LmIcon, ColumnRoleHelp},
  props: {
    options: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      columns: null,
      columnSorted: null
    }
  },
  mounted() {
    this.columns = this.options.map(option => {
      option.orderASC = true
      option.orderIcon = 'arrowDown'
      if (option.defaultOrder) {
        this.columnSorted = option.id
      }
      return option
    })
  },
  destroyed() {
    // TODO Clean up this.columns
  },
  methods: {
    isSelected(id) {
      return this.columnSorted === id
    },
    resolveIcon(column) {
      return column.orderASC ? 'arrowDown' : 'arrowUp'
    },
    sort(column, e) {
      if (e.target.textContent.trim() === 'help') return // click on Help
      if (this.columnSorted !== column.id) {
        this.columnSorted = column.id
        // Reset columns
        this.columns.forEach(c => {
          c.orderIcon = 'arrowDown'
        })
      } else {
        const temp = Object.assign(column, {
          orderASC: !column.orderASC,
          orderIcon: !column.orderASC ? 'arrowDown' : 'arrowUp'
        })
        Vue.set(this.columns, column, temp)
      }
      this.$emit('change-order', column)
    }
  }
}
</script>

<style scoped>
.Column:not(.is-sorted):hover,
.Column:not(.is-sorted):hover .SortIcon {
  color: black;
}
</style>
